import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/ui/Navbar';
import { ScrollToTop } from './components/ui/ScrollToTop';
import { Footer } from './components/ui/Footer';
import { CookieConsent } from './components/ui/CookieConsent';
import { Home } from './pages/Home';
import { Contact } from './pages/Contact';
import { Donations } from './pages/Donations';
import { DonationsPlaceToPay } from './pages/DonationsPlaceToPay';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { History } from './pages/History';
import { News } from './pages/News';
import { NewsDetail } from './pages/NewsDetail';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-zinc-950 flex flex-col">
        <Navbar />
        
        <main className="flex-grow pt-24">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/noticias" element={<News />} />
            <Route path="/noticias/:slug" element={<NewsDetail />} />
            <Route path="/contactenos" element={<Contact />} />
            <Route path="/donaciones" element={<Donations />} />
            <Route path="/donacion" element={<DonationsPlaceToPay />} />
            <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
            <Route path="/historia" element={<History />} />
          </Routes>
        </main>

        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
